import { ServiceType } from "../ServiceManager";
import { WebsiteGeocoderProviderConfig } from "../../types/WebsiteConfig";
import Coordinate from "../../types/Coordinate";
import { Client } from "../API/Client";
import { APIRequest, APIRequestMethod } from "../API/APIRequest";
import { Logger, LogLevel } from "../Logger";
import { IGeocoder } from "./IGeocoder";
import { GeoSearchResult } from "../../types/Geocoding/GeoSearchResult";

interface MapboxGeocodingResponse {
    attribution: string;
    type: string;
    query: string[];
    features: MapboxFeatureResponse[];
}

interface MapboxFeatureContextResponse {
    id: string;
    text: string;
}

interface MapboxFeatureResponse {
    center: number[];
    context: MapboxFeatureContextResponse[];
    geometry: MapboxFeatureGeometryResponse;
    id: string;
    place_name: string;
    place_type: string[];
    properties: any;
    relevance: number;
    text: string;
    type: string;
}

interface MapboxFeatureGeometryResponse {
    type: string;
    coordinates: [];
}

class MapboxGeocoder implements IGeocoder {
    Type: ServiceType = ServiceType.Geocoder;
    Id: string = 'MapboxGeocoder';

    Config: WebsiteGeocoderProviderConfig;

    constructor(config: WebsiteGeocoderProviderConfig) {
        this.Config = config;
    }

    Search(query: string, affinity?: Coordinate): Promise<GeoSearchResult> {
      return new Promise((resolve, reject) => {
        const req = new APIRequest(APIRequestMethod.GET, `/geocoding/v5/mapbox.places/${encodeURIComponent(query)}.json`)
          .SetHost('https://api.mapbox.com')
          .SetQuery({
            autocomplete: true,
            liimt: 5,
            access_token: this.Config.APIKey,
            types: 'address',
            proximity: affinity ? `${affinity.Lon},${affinity.Lat}` : null
        });

        Client.Request<MapboxGeocodingResponse>(req)
          .then((res) => {
            resolve({
              Attribution: res.attribution,
              Results: res.features.map((f) => ({
                Id: f.id,
                Name: f.place_name,
                Suburb: f.context.find((c) => c.id.indexOf('locality.') === 0)?.text,
                Coords: { Lat: f.center[1], Lon: f.center[0] }
              }))
            });
          })
          .catch((err) => {
            reject(err);
          });
      });
    }

    Geocode(address: string): Promise<Coordinate> {
        return new Promise((resolve, reject) => {
            var req = new APIRequest(APIRequestMethod.GET, `/geocoding/v5/mapbox.places/${encodeURIComponent(address)}.json`)
                .SetHost('https://api.mapbox.com')
                .SetQuery({
                    autocomplete: false,
                    limit: 1,
                    access_token: this.Config.APIKey,
                    types: 'address'
                });

            Client.Request<MapboxGeocodingResponse>(req).then(res => {
                if(res == null || res.features.length == 0) {
                    reject();
                    return;
                }

                resolve({ Lat: res.features[0].center[1], Lon: res.features[0].center[0] });
            }).catch(err => {
                Logger.Log(LogLevel.Error, 'Failed to geocode', address, err);
                reject(err);
            });
        });
    }
}

export { MapboxGeocoder }
